var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"align":"center"}},[_c('div',[_c('v-alert',{attrs:{"outlined":"","type":"info","border":"top","max-width":"500"}},[_vm._v(" "+_vm._s(_vm.$t('common.inactiveModule'))+" ")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }